
import { ProfileDetailsType } from "../../../types/profileDetails/ProfileDetailsType";
import { GET_PROFILE_DETAILS, RESET_GET_PROFILE_DETAILS } from "../../actionTypes/actionsTypes";
import defaultAsyncReducer from "../../defaultReducer";
import { AppAction, BaseAsyncReducerState, LocalAction } from "../../types";

export interface ProfileDetailsState extends BaseAsyncReducerState {
  success: boolean,
  message: string,
  snapshotId: string,
  data: ProfileDetailsType
}

const initialState: ProfileDetailsState = {
  success: false,
  message: "",
  snapshotId: "",
  data: {
    tradeName: "",
    contactName: "",
    contactPosition: "",
    phoneNumber: "",
    phoneExtension: "",
    secondaryPhoneNumber: "",
    secondaryPhoneExtension: "",
    partialIncomeMonth: "",
    email: "",
    fiscalYearEndDate: "",
    ownerOccupiedFlag: null,
    acknowledgementFlag: null,
    agentFlag: null,
    analysisFlag: null,
    analysisReviewedBy: "",
    analysisReviewedDate: "",
    reviewedFlag: null,
    reviewedBy: "",
    reviewedDate: null,
    hasApartmentFlag: null,
    hasCommercialFlag: null,
    hasAffordableHousingFlag: null,
    affordableHousingAgreementCodes: null,
    affordableHousingCount: null,
    firstName: "",
    lastName: ""
  },
  loading: false,
  error: false
}

function getProfileDetailsReducer(state = initialState, action: AppAction | LocalAction) {
  if (action.type === RESET_GET_PROFILE_DETAILS) {
    return initialState;
  } else {
    return defaultAsyncReducer(state, action as AppAction, GET_PROFILE_DETAILS)
  }
}

export default getProfileDetailsReducer;